








































import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import formatter from '@/mixins/formatter';

import Price from '@/components/Atoms/Text/Price.vue';
import Number from '@/components/Atoms/Input/Number.vue';
import TextLink from '@/components/Atoms/Link/TextLink.vue';

import ProductCount from '@/components/Molecules/Input/ProductCount.vue';
import ListItem from '@/components/Atoms/ListItem/ListItemWithBorder.vue';

@Component({
  components: {
    ListItem,
    Price,
    TextLink,
    Number,
    ProductCount,
  },
})
export default class VasItem extends mixins(formatter) {
  @Prop() private item!: any;
  @Prop() private index!: number;
  private namespace: string = 'vas';
  count = 0;

  priceName(product: any): string {
    switch (product.categoryId) {
      case 'mma':
        return '1ID　';
      case 'mdm':
        return '1台　';
      case 'office365':
        // ====通常時は↓↓↓を有効化======================================================
        return '1ライセンス　';
        // ====通常時は↑↑↑を有効化======================================================
        // ====料金改定事前告知時は↓↓↓を有効化==========================================
        //return '2024年3月ご利用分まで 1ライセンス　';
        // ====料金改定事前告知時は↑↑↑を有効化==========================================
      default:
        return '';
    }
  }

  priceNote(product: any): string {
    switch (product.id) {
      case 'office_be':
        return '2024年4月ご利用分から 1ライセンス 1,076円(税別)/月 予定*';
      case 'office_b':
        return '2024年4月ご利用分から 1ライセンス 1,490円(税別)/月 予定*';
      case 'office_bp':
        return '2024年4月ご利用分から 1ライセンス 2,251円(税別)/月 予定*';
      default:
        return '';
    }
  }

  unitName(product: any): string {
    switch (product.categoryId) {
      case 'mma':
        return 'ID';
      case 'mdm':
        return '台';
      case 'office365':
        return 'ライセンス';
      default:
        return '回線';
    }
  }

  get payload(): { id: string } {
    return { id: this.item.id };
  }

  get selected(): boolean {
    return this.count > 0;
  }

  get hasError(): boolean {
    return this.count > this.item.maxValue;
  }

  get validateRules(): string {
    return `max_value:${this.item.maxValue}`;
  }

  updateCount(count: number) {
    this.count = count;
  }
}
